import React from "react";
import { HiOutlinePlus } from "react-icons/hi2";
import { useTranslation } from "react-i18next";

interface PeopleListProps {
  title: string;
  people: any[];
  colors: Record<string, string>;
  onAdd: () => void;
}

const PeopleList: React.FC<PeopleListProps> = ({
  title,
  people,
  colors,
  onAdd,
}) => {
  const { t } = useTranslation(); // Initialize translation

  const getInitials = (firstName: string, lastName: string) => {
    return `${firstName.charAt(0)}${lastName.charAt(0)}`;
  };

  return (
    <div className="w-full p-6 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 bg-white dark:bg-gray-800 transition-shadow hover:shadow-md">
      <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-5">
        {title}
      </h3>
      {people.length > 0 ? (
        <ul className="flex flex-col gap-2 mb-5">
          {people.map((person) => (
            <li
              key={person.id}
              className="flex items-center gap-3"
            >
              <div
                className={`flex items-center justify-center w-10 h-10 ${
                  colors[person.id] || "bg-[#5932EA]/80"
                } rounded-full text-white text-sm font-semibold shrink-0 shadow-sm ring-2 ring-white dark:ring-gray-800`}
              >
                {person.imageURL ? (
                  <img
                    src={person.imageURL}
                    alt={`${person.firstName} ${person.lastName}`}
                    className="rounded-full w-10 h-10 object-cover"
                  />
                ) : (
                  <span>{getInitials(person.firstName, person.lastName)}</span>
                )}
              </div>
              <span className="text-gray-800 dark:text-gray-200 font-medium truncate">
                {person.firstName} {person.lastName}
              </span>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-gray-500 dark:text-gray-400 text-sm mb-5">
          {t("noPeopleAssigned", { title: title.toLowerCase() })}
        </p>
      )}

      <button
        onClick={onAdd}
        className="flex items-center gap-2 px-4 py-2.5 rounded-xl text-[#5932EA] hover:bg-[#5932EA]/10 dark:hover:bg-[#5932EA]/20 font-medium text-sm transition-all"
      >
        <HiOutlinePlus className="w-4 h-4" />
        {t("add")} {title}
      </button>
    </div>
  );
};

export default PeopleList;
